import NumberFormat from "react-number-format";

interface NumberFormatCustomProps {
    inputRef: (instance: NumberFormat<string | number> | null) => void;
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}
export function NumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo.source === 'event') {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          })
        }
      }}
      thousandSeparator
      isNumericString
    />
  )
}
